<div oncontextmenu="return false;" (click)="httpService.contextmenu ? disableContextMenu() : ''"
  id="directoryStructure">
  <div *ngFor="let library of assetLibrary;index as i" id="{{library?.name + i}}" [ngStyle]="{'color':theme_color==='dark'?'white':'black'}">
    <p [ngClass]="{'cursor-pointer' : library._id}" mwlDroppable (drop)="drop($event, library)"
      dragOverClass="drop-over-active" *ngIf="library?.name !== 'root' && library?.name !=='`!234' && !library.rename"
      (click)="addSubfolder(library)" (contextmenu)="onrightClick($event, library)" id="folderClick">
      <sh-icon class="icon-style" icon="open" *ngIf="library._id"></sh-icon><b>{{ library?.name }}</b>
    </p>

    <div *ngIf="library.rename">
      <sh-input-text label='Folder Name' [value]='httpService.folder.name' (value-changed)="modelChange($event)">
      </sh-input-text>
      <sh-icon class="display-inline-box" button color="secondary" icon="success" (click)="renameFolder()">
      </sh-icon>
      <sh-icon class="display-inline-box" button icon="error"></sh-icon>
    </div>

    <!-- <div *ngIf="library?.name === '`!234'" style="padding: 10px">
      <sh-input-text label='Folder Name' [value]=folderName (value-changed)="folderName=$event.target.value"
        [error]="folderNameError || folderNameExists" id="newFolderName"
        (blur)="folderNameError = (folderName === '' || folderName.trim() === '');folderNameValidation($event.target.value)"></sh-input-text>
      <sh-icon style="display: -webkit-inline-box" button color="secondary" icon="success" (click)="addNewFolder()">
      </sh-icon>
      <sh-icon style="display: -webkit-inline-box" button icon="error" (click)="removeFolder()"></sh-icon>
      <sh-tooltip *ngIf="folderNameError" label="Please enter the Folder Name" target="newFolderName"
        placement="bottom-left" variation="short"></sh-tooltip>
        <sh-tooltip label="Folder name can only contain '-','_' as special characters. Folder name cannot start or end with '-','_'" target="newFolderName"
        placement="bottom-left" variation="short"></sh-tooltip>
      <sh-tooltip *ngIf="folderNameExists" label="The entered Folder Name exists. Please enter a different Folder Name"
        target="newFolderName" placement="bottom-left" variation="short"></sh-tooltip>
    </div> -->
    <!-- <div *ngIf="httpService.contextmenu && !isPersonalBrowser">
      <app-context-menu [x]="httpService.contextmenuX" [y]="httpService.contextmenuY"></app-context-menu>
    </div> -->
    <div class="margin-left-10">
      <app-library-browser [assetLibrary]="library?.subFolders" (selectedAsset)="selectAsset($event)"
        [isPersonalBrowser]="isPersonalBrowser" (assetCardId)="fetchCardDetails($event)" [isUpload]="isUpload"
        (assetRelativePath)="assetRelativePathRecive($event)" (parameterUrl)="parameterUrl2($event)"></app-library-browser>
    </div>

    <div *ngIf="!isUpload">
      <div class="margin-left-10" *ngFor="let asset of library?.assetList">
        <p [ngStyle]="{'color':theme_color==='dark'?'white':'black'}" *ngIf="(userService.loggendInUser.assetsOwned && userService.loggendInUser.assetsOwned.indexOf(asset?._id) >= 0) || (userService.loggendInUser.assetsUploaded && userService.loggendInUser.assetsUploaded?.indexOf(asset?._id) >= 0); else noneDrag"
          class="cursor-pointer" (click)="onAssetSelect(asset, library)" id="assetClicked" draggable="true" mwlDraggable
          (dragStart)="drag($event, asset, library)">
          <sh-icon class="icon-style" icon="document"></sh-icon> <span
            [ngClass]="{'selected' : asset.selectedAsset}">{{ asset?.name }}</span>
        </p>

        <ng-template #noneDrag>
          <p class="cursor-pointer" (click)="onAssetSelect(asset, library)" id="assetClicked">
            <sh-icon class="icon-style" icon="document"></sh-icon> <span
              [ngClass]="{'selected' : asset.selectedAsset}">{{ asset?.name }}</span>
          </p>
        </ng-template>
      </div>
    </div>
    
  </div>

  <sh-notifications class="library-browser-notify">
    <sh-notification-item  [visible]="isShowNotificationAlert" 
      type="alert"
      label="Alert">
      {{showAlertMessage}}
    </sh-notification-item>
  </sh-notifications>
  
</div>

